import Vue from 'vue'
import VueRouter from 'vue-router'
import TheHome from '@/views/TheHome.vue'
// import { Callbacks } from 'jquery'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'TheHome',
    component: TheHome,
    meta: { requiresAuth: true },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/News',
    name: 'News',
    component: () => import('../views/News.vue')
  },

  {
    path: '/Room',
    name: 'Room',
    component: () => import('../views/Room.vue')
  },
  //   房型
  {
    path: '/BusinessRoom',
    name: 'BusinessRoom',
    component: () => import('../views/BusinessRoom.vue')
  },
  {
    path: '/Honeymoon',
    name: 'Honeymoon',
    component: () => import('../views/Honeymoon.vue')
  },
  {
    path: '/DukeDoubleRoom',
    name: 'DukeDoubleRoom',
    component: () => import('../views/DukeDoubleRoom.vue')
  },
  {
    path: '/CozyDoubleRoom',
    name: 'CozyDoubleRoom',
    component: () => import('../views/CozyDoubleRoom.vue')
  },
  {
    path: '/DeluxeQuadrupleRoom',
    name: 'DeluxeQuadrupleRoom',
    component: () => import('../views/DeluxeQuadrupleRoom.vue')
  },
  {
    path: '/VIPQuadrupleRoom',
    name: 'VIPQuadrupleRoom',
    component: () => import('../views/VIPQuadrupleRoom.vue')
  },
  //   房型
  {
    path: '/Traffic',
    name: 'Traffic',
    component: () => import('../views/Traffic.vue')
  },

  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('../components/login.vue')
  // },
  {
    path: '/The_Sidebar',
    name: 'The_Sidebar',
    component: () => import('../components/The_Sidebar.vue')
  },
  {
    path: '/FooterNav',
    name: 'FooterNav',
    component: () => import('../components/footer.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
